import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  button: {
    width: 'fit-content'
  }
}))
